import type { UserGetByIdRequest, UserSearchRequest } from '@trukt/tms-api/UserService';
import { createKey } from './createKey';

const keyHandler = createKey('user');

export const UserServiceKeys = {
  key: keyHandler.key,
  search: keyHandler.createMethod<UserSearchRequest>(),
  getMe: keyHandler.createMethod<void>(),
  getById: keyHandler.createMethod<UserGetByIdRequest>(),
};
